import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _PlayFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m21.588 9.769-10.43-5.344C9.249 3.445 7 4.87 7 7.059v10.103c0 2.189 2.248 3.613 4.159 2.633l10.429-5.344c1.883-.964 1.883-3.718 0-4.682" })));
}
const PlayFill = forwardRef(_PlayFill);
export { PlayFill };
